module.exports = __webpack_public_path__ + "img/ktzy-colour.3a9a7600.png";